import { Link } from "react-router-dom";
import { LegalLayout, H2, P, A, UL, Strong } from "@/components/LegalLayout";

const LAST_UPDATED = "June 16, 2026"; // [DATE]
const CONTACT_EMAIL = "support@aipathshaalaa.com"; // [EMAIL]

export default function Terms() {
  return (
    <LegalLayout testid="terms-page" eyebrow="Legal" title="Terms of Service" updated={LAST_UPDATED}>
      <P>
        Welcome to AI Pathshaalaa. By creating an account or using the Platform, you agree to these
        Terms of Service. Please read them together with our{" "}
        <Link to="/privacy" className="text-primary font-semibold underline underline-offset-2">Privacy Policy</Link>{" "}
        and our{" "}
        <Link to="/youtube-compliance" className="text-primary font-semibold underline underline-offset-2">YouTube API Services Compliance Policy</Link>.
      </P>

      <H2>1. What AI Pathshaalaa Is</H2>
      <P>
        AI Pathshaalaa is an independent education service that discovers publicly available educational
        videos through official YouTube API Services and sequences them into AI-curated learning
        courses — with roadmaps, AI-generated summaries, quizzes, practice tasks, and progress
        tracking. <Strong>We are not affiliated with, endorsed by, or sponsored by YouTube or
        Google.</Strong>
      </P>

      <H2>2. You Are Also Bound by YouTube's Terms</H2>
      <P>
        Because videos play through the official YouTube embedded player, by using AI Pathshaalaa you
        also agree to be bound by the <A href="https://www.youtube.com/t/terms">YouTube Terms of
        Service</A>. Our use of information from YouTube API Services is subject to the{" "}
        <A href="https://policies.google.com/privacy">Google Privacy Policy</A>.
      </P>

      <H2>3. What We Charge For — Curation, Not Videos</H2>
      <P>
        Our free tier always includes the playable, officially-embedded YouTube videos, your
        personalized roadmap, and basic progress tracking. <Strong>Any fee on AI Pathshaalaa is solely
        for our own value layer</Strong> — AI-generated lesson summaries, full quizzes, practice
        tasks and projects, prompt templates, downloadable notes, the "Ask AI" doubt solver,
        analytics and personalization. <Strong>We do not, and never will, charge for access to the
        YouTube videos themselves.</Strong> The videos remain free on YouTube.
      </P>

      <H2>4. Videos Remain the Property of Their Creators and YouTube</H2>
      <P>
        All videos embedded on the Platform are the property of their original creators and YouTube.
        We do not host, download, copy, cache, or rehost any video or audio. All views, watch time,
        and any ad revenue belong entirely to the creators and YouTube. Every video is attributed to
        its creator and links back to the original on YouTube.
      </P>

      <H2>5. Accounts</H2>
      <P>
        You are responsible for keeping your login credentials secure and for activity under your
        account. You must provide accurate information and be old enough to use the Platform under the
        laws of your country.
      </P>

      <H2>6. Payments &amp; Refunds</H2>
      <UL>
        <li>Paid plans unlock only our curation and learning features, as described in Section 3.</li>
        <li>One-time course unlocks and subscriptions are billed via our payment processor in INR.</li>
        <li>You may cancel a subscription at any time; access continues until the end of the billing period.</li>
        <li><Strong>7-day money-back guarantee:</Strong> within 7 days of any payment you can request a full,
          no-questions-asked refund in one click from your <Strong>Account</Strong> page. The refund is issued to
          your original payment method and typically arrives within 5–7 business days; Pro access ends when the
          refund is issued.</li>
        <li>For any other refund questions, contact us at <Strong>{CONTACT_EMAIL}</Strong>.</li>
      </UL>

      <H2>7. Acceptable Use</H2>
      <P>
        You agree not to scrape, resell, or redistribute our curated content, attempt to download the
        underlying videos, circumvent YouTube's player or branding, or use the Platform in any way
        that violates YouTube's Terms or applicable law.
      </P>

      <H2>8. Disclaimer</H2>
      <P>
        Educational content is provided "as is". Video availability depends on YouTube and creators;
        a video may be removed at any time, in which case it will no longer appear on the Platform.
      </P>

      <H2>9. Contact</H2>
      <P>Questions about these Terms? Email us at <Strong>{CONTACT_EMAIL}</Strong>.</P>
    </LegalLayout>
  );
}
